<template>
  <div>
    <div class="card bet-board-card animate-slide-y">
      <div class="card-text">
        <div>
          <div class="mb-4 flex items-center gap-1 font-medium">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            ><path
              fill-rule="evenodd"
              d="M3 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H3.75A.75.75 0 013 10z"
              clip-rule="evenodd"
            ></path>
            </svg> เลือกประเภทการแทง
          </div>
          <div class="grid grid-cols-2 gap-2 pb-4 sm:grid-cols-3 lg:grid-cols-5">
            <div 
              v-for="(winTab, index) in winTabs" 
              :key="index"
              class="v-popper v-popper--theme-tooltip"
            >
              <button
                class="bet-type-choice-btn w-full px-2"
                :class="{'active': selectType.includes(winTab.number_type.id)}"
                type="button"
                @click="changeStatus(winTab)"
              >
                <div class="flex items-center justify-center">
                  <div class="flex w-full items-center justify-center font-bold">
                    {{ winTab.number_type.name }}
                    <span class="pay-rate-chip chip ml-2 rounded-full text-xs font-semibold">{{ winTab.userReward | number_comma }}</span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="mb-2 flex min-h-[46px] items-center justify-between gap-2">
          <div class="flex items-center gap-1 font-medium">
            <svg
              data-v-aee14c88=""
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            ><path
              fill-rule="evenodd"
              d="M3 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H3.75A.75.75 0 013 10z"
              clip-rule="evenodd"
            ></path></svg> กดเลข
          </div>
          <ReverseNumber
            v-if="inputDigit != 1"
            :value="reverseNumber"
            @change="reverseNumber=!reverseNumber"
          ></ReverseNumber>
        </div>
        
        <div 
          v-if="inputDigit == 2"
          class="mb-2 flex items-center gap-2"
        >
          <div class="min-w-[4rem] pb-1 font-medium font-basic">
            19 ประตู
          </div><div class="two-digit-choice grid w-full grid-cols-5 gap-1 rounded-lg p-1 sm:grid-cols-10 md:w-auto lg:w-auto">
            <button
              v-for="digit in twoDigits"
              :key="digit"
              class="min-h-5 py-1 px-3"
              :class="{
                'active': selectNineteenNumber.includes(digit)
              }"
              type="button"
              @click="onSelectNineteen(digit)"
            >
              <div class="flex items-center justify-center">
                {{ digit }}
              </div>
            </button>
          </div>
        </div>

        <div 
          v-if="inputDigit == 2"
          class="mb-2 flex items-center gap-2"
        >
          <div class="min-w-[4rem] pb-1 font-medium font-basic">
            รูดหน้า
          </div><div class="two-digit-choice grid w-full grid-cols-5 gap-1 rounded-lg p-1 sm:grid-cols-10 md:w-auto lg:w-auto">
            <button
              v-for="digit in twoDigits"
              :key="digit"
              class="min-h-5 py-1 px-3"
              :class="{
                'active': selectFrontRoot.includes(digit)
              }"
              type="button"
              @click="onSelectFrontRoot(digit)"
            >
              <div class="flex items-center justify-center">
                {{ digit }}
              </div>
            </button>
          </div>
        </div>

        <div 
          v-if="inputDigit == 2"
          class="mb-2 flex items-center gap-2"
        >
          <div class="min-w-[4rem] pb-1 font-medium font-basic">
            รูดหลัง
          </div><div class="two-digit-choice grid w-full grid-cols-5 gap-1 rounded-lg p-1 sm:grid-cols-10 md:w-auto lg:w-auto">
            <button
              v-for="digit in twoDigits"
              :key="digit"
              class="min-h-5 py-1 px-3"
              :class="{
                'active': selectBackRoot.includes(digit)
              }"
              type="button"
              @click="onSelectBackRoot(digit)"
            >
              <div class="flex items-center justify-center">
                {{ digit }}
              </div>
            </button>
          </div>
        </div>

        <div 
          v-if="inputDigit > 2"
          class="number-board choice grid grid-cols-5 gap-2 py-2 sm:grid-cols-10"
        >
          <button
            v-for="(number) in prefixNumbers"
            :key="number"
            class="py-1"
            :class="{'active': number == selectPrefix}"
            type="button"
            @click="onSelectPrefix(number)"
          >
            <div class="flex items-center justify-center">
              {{ number }}
            </div>
          </button>
        </div>

        <div
          v-if="inputDigit == 4"
          class="divider"
        ></div>

        <div 
          v-if="inputDigit == 4"
          class="number-board choice grid grid-cols-5 gap-2 py-2 sm:grid-cols-10"
        >
          <button
            v-for="(number) in subPrefixNumbers"
            :key="number"
            class="py-1"
            :class="{'active': number == selectSubPrefix}"
            type="button"
            @click="onSelectSubPrefix(number)"
          >
            <div class="flex items-center justify-center">
              {{ number }}
            </div>
          </button>
        </div>

        <div
          v-if="inputDigit > 2"
          class="three-digit-range my-2 rounded-full py-1 text-center font-semibold"
        >
          {{ rangeWording }}
        </div>

        <div class="number-board grid grid-cols-5 gap-2 py-2 sm:grid-cols-10">
          <button
            v-for="item in generateInputList()"
            :key="item.valueUnique"
            class="py-1"
            :class="{
              'active': selectedUnique.includes(item.valueUnique) && item.status != ALMOST,
              'color-warning': selectedUnique.includes(item.valueUnique) && item.status == ALMOST,
            }"
            type="button"
            :disabled="checkDisable(item)"
            @click="onEnter(item.number)"
          >
            <div class="flex items-center justify-center">
              {{ checkDisable(item) ? $t('button.out-of-stock') : item.number }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { findPermutations } from '@/plugins/helper'
import ReverseNumber from './ReverseNumber'

const OPTION_NINETEEN = 'nineteen'
const OPTION_FRONT_ROOT = 'front_root'
const OPTION_BACK_ROOT = 'back_root'

const FORCE_ADD = 1
const FORCE_DEL = -1

export default {
  components:{
    ReverseNumber
  },
  props : {
    switchToggle : {
      type:Boolean,
      default:false
    },
    indexSelect : { 
      type:Number,
      default:0
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    filterNumber:{
      type:String,
      default:()=>''
    },     
    voucher:{
      type:Object,
      default:()=>{}
    },
    winTabs: {
      type: Array,
      default: () => {
        return []
      }
    }
  },   
  data (){
    return { 
      selectAmount: [],
      selectType: [], 
      toggleSelected: 0,
      selectAmountBase: [],
      selectNineteenNumber: [],
      selectFrontRoot: [],
      selectBackRoot: [],
      LIMITL : 2, 
      ALMOST : 1, 
      NORMAL : 0,
      winNumber: '',
      unSelectAmount: [],
      selectPrefix: null,
      selectSubPrefix: null,
      reverseNumber: false,
    }
  },
  
  computed : {
    OPTION_NINETEEN: () => OPTION_NINETEEN,
    OPTION_FRONT_ROOT: () => OPTION_FRONT_ROOT,
    OPTION_BACK_ROOT: () => OPTION_BACK_ROOT,
    selectWinTabs () { 
      return this.winTabs.filter((x) => this.selectType.includes(x.number_type.id));
    },
    selectTabNumbers () {
      return this.selectWinTabs.map(x => x.number_type.digit)
    },
    selectedUnique () {
      return this.userSelect.map(x => `${parseInt(x.number)}:${x.number_type_id}`)
    },
    prefixNumbers () {

      if (this.inputDigit < 3) {
        return []
      }

      const tab = this.selectWinTabs[0]
      let numbers = []

      for (let i = 0; i < 10; i++) {
        numbers.push((i * (10 ** (tab.number_type.digit - 1))).toString().padStart(tab.number_type.digit, '0'))
      }

      return numbers
    },

    twoDigits () {
      let numbers = []

      for (let i = 0; i < 10; i++) {
        numbers.push(i)
      }

      return numbers
    },

    subPrefixNumbers () {

      if (this.inputDigit < 4) {
        return []
      }

      let numbers = []

      for (let i = 0; i < 10; i++) {
        numbers.push((parseInt(this.selectPrefix) + (i * (10 ** (2)))).toString().padStart(4, '0'))
      }

      return numbers
    },

    rangeWording () {
      const tab = this.selectWinTabs[0]
      let end = parseInt(this.selectPrefix) + (10 ** (tab.number_type.digit - 1)) - 1
      let start = this.selectPrefix

      if (this.selectSubPrefix) {
        start = this.selectSubPrefix
        end = parseInt(this.selectSubPrefix) + (10 ** 2) - 1
      }

      return `${parseInt(start).toString().padStart(tab.number_type.digit, '0')} - ${end.toString().padStart(tab.number_type.digit, '0')}`
    },
    inputDigit () {
      return this.selectTabNumbers[0]
    }

  },
  
  watch:{   
    indexSelect () { 
      this.checkStatusActive()
    },
    toggleSelected () { 
      this.checkStatusActive()
    },

    userSelect () {
      this.checkStatusActive()
    },

    winNumber () {
      this.unSelectAmount = []
    },
  }, 
  async created () { 
    this.checkStatusActive()
    this.selectType.push(this.winTabs[0].number_type.id)
    this.selectPrefix = this.prefixNumbers[0] ?? null
    this.selectSubPrefix = this.subPrefixNumbers[0] ?? null
  },
  methods: {
    generateResult (item, number, index, selectGameOption) {

      let results = []

      for (let i = 0; i <= 99; i++) {
        
        let numberString = i.toString().padStart(2, '0')

        if (selectGameOption == OPTION_NINETEEN && !numberString.includes(number)) {
          continue
        }

        if (selectGameOption == OPTION_FRONT_ROOT && numberString[0] != number) {
          continue
        }

        if (selectGameOption == OPTION_BACK_ROOT && numberString[1] != number) {
          continue
        }

        let result = {
          value : i,
          valueUnique: `${numberString}:${item.number_type.id}`,
          number : numberString,
          status : this.NORMAL,
          userReward : 0,
          index: index,
        } 

        let limitFind = (item.limit_conditions || []).filter(x => x.number === result.number) 
        
        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        results.push(result);
      }

      return results
    },

    generateReverseResult (item, numbers, index) {

      let results = []

      numbers.forEach(i => {

        let result = {
          value : i,
          valueUnique: `${i}:${item.number_type.id}`,
          number : i.toString().padStart(item.number_type.digit, '0'),
          status : this.NORMAL,
          userReward : 0,
          index: index,
        } 

        let limitFind = (item.limit_conditions || []).filter(x => x.number === result.number) 

        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        results.push(result);
      });
        
      return results
    },

    onSelectNineteen (number) {
      const index = this.selectNineteenNumber.indexOf(number);

      if (index !== -1) {
        this.selectNineteenNumber.splice(index, 1);
      } else {
        this.selectNineteenNumber.push(number);
      }

      const force = index !== -1 ? FORCE_DEL : FORCE_ADD

      this.onEnter(number, OPTION_NINETEEN, force)
    },

    onSelectFrontRoot (number) {
      const index = this.selectFrontRoot.indexOf(number);

      if (index !== -1) {
        this.selectFrontRoot.splice(index, 1);
      } else {
        this.selectFrontRoot.push(number);
      }

      const force = index !== -1 ? FORCE_DEL : FORCE_ADD

      this.onEnter(number, OPTION_FRONT_ROOT, force)
    },

    onSelectBackRoot (number) {
      const index = this.selectBackRoot.indexOf(number);

      if (index !== -1) {
        this.selectBackRoot.splice(index, 1);
      } else {
        this.selectBackRoot.push(number);
      }

      const force = index !== -1 ? FORCE_DEL : FORCE_ADD

      this.onEnter(number, OPTION_BACK_ROOT, force)
    },

    onEnter (x, selectGameOption, forceAdd) {
      for (let i = 0; i < this.winTabs.length; i++) {
        if (!this.selectType.includes(this.winTabs[i].number_type.id)) {
          continue
        }

        // if (this.selectAmount.includes(item.valueUnique)) {
        //     return;
        //   }

        if (this.reverseNumber && !selectGameOption) {
          const permutations = this.getPermutations(x, x.length)

          let results = this.generateReverseResult(this.winTabs[i], permutations, i)
          
          results.forEach(x => {
            this.addValue(x)
          });

          continue
        }

        if (selectGameOption) {

          let results = this.generateResult(this.winTabs[i], x, i, selectGameOption)

          results.forEach(x => {
            x.forceAdd = forceAdd
            this.addValue(x)
          });

          continue;
        }

        let result = {
          value : x,
          valueUnique: `${x}:${this.winTabs[i].number_type.id}`,
          number : this.changeNumbertoString(x),
          status : this.NORMAL,
          userReward : 0,
          index: i
        } 

        let limitFind = (this.winTabs[i].limit_conditions || []).filter(x => x.number === result.number) 
        
        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        this.addValue(result)
      }
    },

    onSelectPrefix (number) {
      this.selectPrefix = number
      this.selectSubPrefix = this.subPrefixNumbers[0] ?? null
    },

    onSelectSubPrefix (number) {
      this.selectSubPrefix = number
    },

    generateInputList () {
      const tab = this.selectWinTabs[0]

      if (tab == undefined) return []

      let index = this.winTabs.findIndex((element) => tab.number_type.id == element.number_type.id);

      let results = []

      let start = 0;
      let end = 10 ** tab.number_type.digit;

      if (this.selectPrefix) {
        start = parseInt(this.selectPrefix)
        end = start + (10 ** (tab.number_type.digit - 1))
      }

      if (this.selectSubPrefix) {
        start = parseInt(this.selectSubPrefix)
        end = start + (10 ** 2)
      }

      for (let i = start; i < end; i++) {
        
        let result = {
          value : i,
          valueUnique: `${i}:${tab.number_type.id}`,
          number : i.toString().padStart(tab.number_type.digit, '0'),
          status : this.NORMAL,
          userReward : 0,
          index: index,
        } 

        let limitFind = (tab.limit_conditions || []).filter(x => x.number === result.number) 
        
        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        results.push(result);
      }
    
      return results
    },

    getPermutations (str, length) {
      if (length === 1) return str.split('');

      const perms = new Set();
      for (let i = 0; i < str.length; i++) {
        const char = str[i];
        const remainingChars = str.slice(0, i) + str.slice(i + 1);
        const remainingPerms = this.getPermutations(remainingChars, length - 1);
        for (const perm of remainingPerms) {
          perms.add(char + perm);
        }
      }
      return Array.from(perms);
    },

    selectAmountList (tab, index) {

      return this.getPermutations(this.winNumber, tab.number_type.digit).map(x => {

        let result = {
          value : x,
          valueUnique: `${x}:${tab.number_type.id}`,
          number : this.changeNumbertoString(x),
          status : this.NORMAL,
          userReward : 0,
          index: index
        } 

        let limitFind = (tab.limit_conditions || []).filter(x => x.number === result.number) 
        
        if(limitFind && limitFind.length !==0){   
          let reward = Math.min.apply(Math,limitFind.map(x=>x.quota_reward))  
          result.status = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward =  reward
        }

        return result
      })
    },

    checkLimitCondition (item) { 
      let check = item.status ? item.status : null
      switch(check){
        case this.NORMAL:
          return ''
        case this.ALMOST:
          return 'red'
        case this.LIMITL:
          return 'red'
          
      }
      return '' 
    }, 

    changeStatus (item) { 

      const id = item.number_type.id

      this.$ga.event('Button', 'ToggleSelectType', 'ThreeDigitPage', item.number_type.name)
      this.$emit('changeStatus', id)
      this.checkStatusActive ()

      const index = this.selectType.indexOf(id);

      if (index !== -1 && this.selectType.length == 1) {
        return
      }
      
      if (index !== -1) {
        this.selectType.splice(index, 1);
      } else if (!this.selectTabNumbers.includes(item.number_type.digit))  {
        this.selectType = []
        this.selectType.push(id);

        this.selectPrefix = this.prefixNumbers[0] ?? null
        this.selectSubPrefix = this.subPrefixNumbers[0] ?? null
      } else {
        this.selectType.push(id);
      }
    }, 
    
    checkDisable (item) {
      let check = item.status ? item.status : null

      return check === this.LIMITL ? true : false
    }, 

    checkStatusActive () {
      this.resetBoardDisplay()

      this.userSelect.forEach(element => {
        this.selectAmount.push(`${element.number}:${element.number_type_id}`) 
      }); 
    },

    resetBoardDisplay () {  
      this.selectAmount = []  
    },

    changeNumbertoString (value){   
      return value.toString()  
    },

    switchNumbertoString (value) {
      return findPermutations(this.changeNumbertoString(value))
      .filter(x=>!this.selectAmount.includes(parseInt(x)))
      .map(x=>this.selectAmountBase.find(y=>y.number===x)) 
    },

    async addValue (item) {
      let changeNumbertoString = item.number

      this.$ga.event('Button', 'Add&DeleteValue', 'WinDigitPage', changeNumbertoString)

      let arrayResult = this.switchToggle && !this.selectAmount.includes(item.valueUnique) 
      ? this.switchNumbertoString (item.value)
      : [item]

      this.loopAdd(arrayResult)
    },  

    loopAdd (array) { 
      let Bypass = false 
      let stakeMaxNumber = (this.voucher.rules || {}).stake_max_number
      let checkVoucherStake = this.voucher.rules && stakeMaxNumber

      array.forEach(e=>{
        let status = this.selectAmount.includes(e.valueUnique)

        let actionStatus = status ? 'delValue': 'addValue' 

        if (e.forceAdd == FORCE_ADD && status) {
          return
        }

        if (e.forceAdd == FORCE_DEL && !status) {
          return
        }
  
        if( checkVoucherStake &&
            this.userSelect.length >= parseInt(stakeMaxNumber) &&
            actionStatus === 'addValue'
        ) { 
          if(!Bypass) {  
            this.$nextTick(()=>{
              this.checkStatusActive() 
            }) 
          }
          
          Bypass = true
          return
        } 

        if (e.status !== this.LIMITL){ 
          let price = e.status === this.NORMAL ? this.winTabs[e.index].userReward : e.userReward
          this.$emit(actionStatus,price,e.number,this.winTabs[e.index].number_type.id, null, null, null)
        }
      }) 
    },

    onClickAmount (item) {
      const index = this.unSelectAmount.indexOf(item.valueUnique);

      if (index !== -1) {
        this.unSelectAmount.splice(index, 1);
      } else {
        this.unSelectAmount.push(item.valueUnique);
      }
    },

    filterNumberInput (event) {
      this.winNumber = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    }
  }
}
</script> 
<style scoped>
@media only screen and (min-width: 1264) {
  .column-five {
    flex: 0 0 10% !important;
    max-width: 10% !important;
  }
}

.win-number {
  max-width: 320px;
}

.bet-board-card {
  --tw-text-opacity: 1;
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
  color: rgb(0 0 0 / var(--tw-text-opacity));
  --tw-gradient-from: #fd9f59 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(253, 159, 89, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #f5781d var(--tw-gradient-to-position);
}

.card {
  background: radial-gradient(ellipse at center top,  var(--bg-secondary-color-v2), var(--bg-secondary-color-v2), var(--bg-secondary-color-v2));
  border-style: none;
  border-radius: .5em;
}

.bet-board-card .card-text, .bet-board-card .card-title {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.bet-board-card .bet-type-choice-btn, .bet-board-card .two-digit-feature-btn {
  --tw-text-opacity: 1;
  background: radial-gradient(ellipse at center top, #383838, #171717);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

svg {
  height: 1.25rem;
  width: 1.25rem;
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.bet-board-card .bet-type-choice-btn.active, .bet-board-card .two-digit-feature-btn.active {
  border-width: 1px;
  --tw-border-opacity: 1;
  background: radial-gradient(ellipse at center top, #fff, #fff);
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.bet-board-card .bet-type-choice-btn.active .pay-rate-chip, .bet-board-card .two-digit-feature-btn.active .pay-rate-chip {
  --tw-text-opacity: 1;
  background: radial-gradient(ellipse at center top, #383838, #171717);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.card .card-text {
  padding: .75rem;
}

.card .card-actions {
    padding: .75rem;
}

.input-group {
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: .25rem;
  color: #374151;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  transition: all .2s cubic-bezier(.4,0,.2,1);
}

input {
  padding: .5rem .75rem;
  outline:none;
}

.preview-win-number {
  background-image: linear-gradient(to bottom, var(--bg-primary-300));
  background-color: var(--bg-primary-300);
}

.card .card-title {
  align-items: center;
  color: #1f2937;
  display: flex;
  font-size: 1.125rem;
  font-weight: 600;
  justify-content: space-between;
  padding: .75rem;
}

.preview-type {
  border-radius: .5rem;
  --tw-bg-opacity: 1;
  background-color: var(--bg-secondary-color-v2);
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: var(--bg-secondary-color-v2);
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.btn:hover, [type=button]:hover, [type=submit]:hover, button:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  filter: brightness(.9);
}

.bet-board-card .bet-type-choice-btn .pay-rate-chip, .bet-board-card .two-digit-feature-btn .pay-rate-chip {
  --tw-bg-opacity: 1;
  background-color: rgba(251, 239, 231);
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.bet-board-card .number-board button {
  border-color: rgba(0, 0, 0, .5);
  border-width: 1px 1px 2px;
  background: radial-gradient(ellipse at center top, #fff, #fff);
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.bet-board-card .number-board button.active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-text-opacity: 1;
  background: var(--bg-active);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.number-board button {
  border-color: rgba(0, 0, 0, .5);
  border-width: 1px 1px 2px;
  --tw-bg-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
  border-style: solid;
}

.bet-board-card .three-digit-range {
  border-width: 1px;
  --tw-border-opacity: 1;
  /* background: radial-gradient(ellipse at center top, #fbefe7, #ffe6d3, #fbefe7); */
  background: white;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.divider {
  border-top: 1px solid #000;
}

.bet-board-card .two-digit-choice button {
  border-width: 1px 1px 2px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(251, 239, 231, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.btn .disabled, .btn:disabled, [type=button] .disabled, [type=button]:disabled, [type=submit] .disabled, [type=submit]:disabled, button .disabled, button:disabled {
  cursor: not-allowed !important;
  opacity: .5;
  pointer-events: none;
}

.color-warning {
  background: unset !important;
  background-color: #FF7F50 !important;
}

.bet-board-card .three-digit-choice button.active, .bet-board-card .two-digit-choice button.active {
  color: rgb(255 255 255 / var(--tw-text-opacity));
  background-color: var(--bg-secondary-color-v2);
}

</style>